import React from "react";

const Homepage = () => {

    return(
        <div className="home">
        <img className="main-image" width="92%"  src="https://s3-alpha-sig.figma.com/img/536c/8cc0/19af9914fd389874fa40c450f8465269?Expires=1579478400&Signature=WjWV9Ds9bDm1rxfXplkyGfklfXMjerm~uw338q8DJYfe1jampDHI2T0sGfEWTQj5bT~25rcryhw3n8K1oKmpnN9mKdlj30AKjW1Ryf7AYkDoBtpWG~slGoP5TV9N5oWrnCdUchFDyEvD-sjjmcpkMReODH284d4RJaxTEVd73qiWoCJkU5R3gUqTKFRX-k3RLPbHQwlG~99tIrqSyIbVYN7b8nFuKV0f1sWqM9bz1dKJbbd0H9upCEe79HHHycQKoGPHdbjMwWK2AQRFkQJc1RCoShEHFraouOqC8qwO3xQwKWdLw-eeoxgoOv0bp6p97~7WRBLRC4jl9s6gVcLnVQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"/>
            <h4 className="image-text">Fresh Produce From Your Local Farmers</h4>

        
            <div className="image-text-small">
                <p>Skip the supermarket. </p>
            <p>Buy fresh from the farmers in your area.</p>
            <p>Get your produce straight out of the fields.</p>
            </div>
        
        </div>

    )

}

export default Homepage;
